import React from "react";

export const Offer = () => {
  return (
    <>
      {/* <div className="bg-[#fcb3fc] text-white p-4">
        <div className="flex justify-center text-2xl items-center p-8 md:p-8">
          What we offer ?
        </div>
       
          <div className="flex pb-6 md:pb-10 text-lg">
            <div className="ml-60">
            
              <li>Charity Onboarding is Free</li>
              <li>Real-Time Dashboard</li>
           
           
              <li>
                Accepts Donations from Any
                 Payment Method
              </li>
              </div>
              <div className="ml-40">
              <li>24/7 Support Email</li>
          
           
              <li>Create Fundraising is Free</li>
              <li>Feedback or Survey</li>
              </div>
      
        </div>
      </div> */}
      <div className="flex flex-col items-center justify-center p-4 md:p-8 mb-8 md:mb-16 px-4 md:px-24">
        <h2 className="p-2 text-center text-3xl" style={{ fontFamily: "'Playfair Display', serif"}}>WHAT WE BELIEVE ?</h2>
        <p className="tracking-widest pt-4 md:pt-6 leading-relaxed break-words w-1/2 max-w-full text-justify">
          Join the DONATE GREAT, make hearts resonate,
           A charity platform that truly great,
           Where kindness and giving collaborate,
          On the homescreen, it&apos;s your fate.
        </p>
      </div>
    </>
  );
};
